export default "__VITE_ASSET__76690ea2__"